<template>
  <div>
    <v-app-bar absolute id="app-bar" color="#81C0E2" style="height: 64px" elevate-on-scroll scroll-target="#scrolling-techniques-7">
      <div class="d-inline-block" style="width:160px">
        <v-img :src="images.new_logo" width=280 alt="中華企業資源規劃學會LOGO"></v-img>
      </div>
    </v-app-bar>
    <v-row style="height:64px; width:100%">
    </v-row>
    <v-row class="ma-5" style="height:40px;">
      <!-- <v-btn  class="ma-0 pa-0" outlined style="width:130px; height:40px; background:#FFF; border-radius:8px; border: 1px solid #969698" @click="redirectPath('/login')">
        <v-icon style="color:#969698">mdi-arrow-left-bold-circle-outline</v-icon>
        <span class="px-1" style="font-size:13pt; color:#969698">回登入頁</span>
      </v-btn> -->
    </v-row>
    <v-card color="#FFF" style="box-shadow:none; overflow-x:hidden; overflow-y:scroll" align="center" :style="viewStyle">
      <v-row class="ma-0" justify="center">
        <v-col class="pb-0 col-10 col-sm-9 col-md-8 col-lg-5" align="right">
          <div id="box2" class="my-2 pa-5 py-10" style="min-height:460px">
            <v-row justify="center" class="mt-5">
              <h1>考試連結下載-WindowsLink</h1>
            </v-row>
            <v-row style="height:100px" justify="center">
              <v-col class="col-9 col-sm-9 col-md-8 col-lg-8">
                <v-row align="center" style="height:100%">
                  <div class="loginBtn centerBtn" style="width:100%; cursor: pointer; background:#215DA7" @click="downloadLink()">
                    <h3 class="mx-2" style="color:#FFFFFF">點此下載</h3>
                    <v-icon color="#FFF">mdi-download</v-icon>
                  </div>
                </v-row> 
              </v-col>
            </v-row>
            <v-row class="my-3 pa-0 ma-0" justify="center">
              <v-col cols="10" class="ma-0 pa-0 text-left">
                <h4 class="ma-0 pa-0">1.<a style="color:#000" @click="downloadLink()">下載安裝檔案</a></h4>
                <h4 class="ma-0 pa-0">2.點擊已下載的項目(CERPS專業認證考試.vbs)</h4>
                <h4 class="ma-0 pa-0">3.系統「開啟檔案-安全性警告」提示時，點擊「開啟」</h4>
                <v-img :src="images.windowsLink1" contain height="260" alt="系統公告"></v-img>
                <h3 class="ma-0 pa-0 mt-5 mb-2" style="color:#FF5656">注意事項</h3>
                <h4 class="ma-0 pa-0">*如下載考試系統不成功，請來信附上截圖詢問</h4>
                <h4 class="ma-0 pa-0">*考試過程須確保網路順暢，避免影響您的權益，若有任何疑問請即時聯繫學會人員</h4>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <div class="pt-3 pb-10 col-10">
        <h4 style="font-size:12px">中華企業資源規劃學會 版權所有，禁止未經授權轉貼節錄</h4>
        <h4 style="font-size:12px"> 2009 中華企業資源規劃學會．Chinese Enterprise Resource Planning Society.</h4>
        <h4 style="font-size:12px">校址：(32001)桃園市中壢區中大路300號 管理學院二館6F Tel：(03)426-4248 Fax：(03)426-0076</h4>
      </div>
    </v-card>
    <ShowMsg ref="ShowMsg" />
  </div>
</template>
<script>

import ShowMsg from '@/dialogs/ShowMsg'

export default {
  name: 'DownloadLink',
  components: {ShowMsg},
  data:()=>({
    viewStyle:{},
    images:{
      new_logo: require('@/assets/image/erp_logo.png'),
      demo: require('@/assets/image/demo.jpg'),
      windowsLink1: require('@/assets/image/windowsLink1.png'),
      windows1: require('@/assets/image/windows1.png'),
      mac1: require('@/assets/image/mac1.png'),
      mac2: require('@/assets/image/mac2.png'),
      problem0: require('@/assets/image/problem0.png'),
      problem1: require('@/assets/image/problem1.png'),
      problem2: require('@/assets/image/problem2.png'),
      problem3: require('@/assets/image/problem3.png'),
      problem4: require('@/assets/image/problem4.png'),
      appIcon: require('@/assets/image/appIcon.png'),
    },
    date: null,
  }),
  mounted(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-144 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    downloadLink(){
      window.location.href='https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/file/common/download?name=demo/CERPS專業認證考試.vbs';
      // https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/file/common/download?name=demo/CERPS%E5%B0%88%E6%A5%AD%E8%AA%8D%E8%AD%89%E8%80%83%E8%A9%A6.vbs
    },
  }
}
</script>
